import React, { Fragment, useContext } from 'react'
import withStyles from '@mui/styles/withStyles';
import List from '@mui/material/List'
import Typography from '@mui/material/Typography'
import { LockOutlined } from '@mui/icons-material'
import NavListGroup from './NavListGroup'
import { isAdmin } from '../../lib/userRoles'
import ContextController from '../ContextController'
import { AuthContext } from '../contexts/AuthContext'
import { CloudContext } from '../contexts/CloudContext'

const styles = theme => ({
    toolbar: {
        ...theme.mixins.toolbar,
        display: 'flex',
        paddingLeft: 16,
        alignItems: 'center',
        borderBottom: '3px solid rgba(24,28,33,0.04)',
        minHeight: `${theme.custom.topNavHeight}px !important`,
    },
    header: {
        display: 'flex',
    },
    divider: {
        position: 'relative',
        width: 2,
        height: '2rem',
        margin: 'auto .5rem',
        backgroundColor: '#D8D8D8',
        borderRadius: 1,
    },
    listItem: {
        paddingLeft: '22px',
    },
    accountItems: {
        marginBottom: '1rem',
    },
    actions: {
        borderTopRightRadius: '60rem',
        borderBottomRightRadius: '60rem',
        width: '99%',
    },
})

const NavMenu = ({ classes }) => {
    const { user } = useContext(AuthContext)
    const { selectedCloud } = useContext(CloudContext)

    let securityItems = [{ text: 'Account & Profile', to: '/account' }]
    if (isAdmin(user, selectedCloud)) {
        securityItems.push({ text: 'Manage Users', to: '/users' })
        /* TEMPORARY COMMENT UNTIL FEATURE IS IMPLEMENTED */
        // securityItems.push({ text: 'Manage Domains', to: '/domains', disabled: true })
    }

    if(user.isCoreSuperUser){
        securityItems.push({text: 'Manage Creators', to: '/creators'})
    }
    if (isAdmin(user, selectedCloud)) {
        securityItems.push({ text: 'Manage Companies', to: '/companies' })
        securityItems.push({ text: 'Manage Apps', to: '/apps' })
    }
    return (
        <Fragment>
            <div className={classes.toolbar}>
                <Typography variant="h6" className={classes.header}>
                    {'Tada'}
                    <div className={classes.divider} />
                    {'Admin Portal'}
                </Typography>
            </div>
            <List>
                <ContextController />
                <NavListGroup
                    header="Security"
                    icon={<LockOutlined htmlColor="#000" />}
                    items={securityItems}
                    containerClass={classes.accountItems}
                    buttonClass={classes.actions}
                />
            </List>
        </Fragment>
    )
}

export default withStyles(styles)(NavMenu)
